import { render, staticRenderFns } from "./StripeLiveRefundStatus.vue?vue&type=template&id=22f31413&scoped=true"
import script from "./StripeLiveRefundStatus.vue?vue&type=script&lang=js"
export * from "./StripeLiveRefundStatus.vue?vue&type=script&lang=js"
import style0 from "./StripeLiveRefundStatus.vue?vue&type=style&index=0&id=22f31413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f31413",
  null
  
)

export default component.exports